import api from './ApiService';
//import api from './ApiAuthService';
import apiAuth from './ApiAuthService';

export async function getGroupCities(): Promise<any> {
  try {
    const response = await api.get('/group-cities');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar as regiões', error);
    throw new Error('Erro ao carregar as regiões');
  }
}

export async function getGroupCitiesFilteredUser(): Promise<any> {
  try {
    const response = await apiAuth.get('/group-cities/filtered-user');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar as regiões', error);
    throw new Error('Erro ao carregar as regiões');
  }
}

export async function getGroupCitiesMissing(): Promise<any> {
  try {
    const response = await apiAuth.get('/group-cities/missing');
    return response.data;
  } catch (error) {
    console.error('Erro ao carregar as regiões', error);
    throw new Error('Erro ao carregar as regiões');
  }
}

export async function postGroupCitiesMissing(data: any): Promise<any> {
  try {
    const response = await apiAuth.post('/group-cities/missing', data);
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar as regiões', error);
    // throw new Error('Erro ao carregar as regiões');
  }
}